module.exports = __webpack_public_path__ + "static/media/bigpic-style-fonts.a0e14270.png";